import { css, useTheme } from '@fable/theme'
import { gsap } from 'gsap'
import { Page } from 'components/Page'
import { StatsDebug } from './StatsDebug'
import { StatsModal } from './StatsModal'
import { StatsProfileContent } from './StatsProfileContent'
import { StatsProfileHandler } from './StatsProfileHandler'
import { StatsProfileProviders } from './StatsProfileProviders'
import { StatsScroll } from './StatsScroll'
import { useGSAP } from '@gsap/react'
import { useStats } from './lib/ctx/stats'
import StatsLegacyPage from 'app/social/pages/stats_page/StatsLegacyPage'
import { hasCustomGoals, isAndroidParam } from './lib/utils'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { WebView } from 'components/web_view'
import { StatsInitialState } from './lib/ctx/stats/types'

gsap.registerPlugin(useGSAP, ScrollTrigger)

export const StatsProfilePageContent = () => {
  const stats = useStats((s) => s.stats)
  const { colors } = useTheme()

  return (
    <Page
      className={css`
        background-color: ${colors.uiWhite};
        height: 100%;
        position: relative;
        user-select: none;
      `}
      head={{
        title: stats?.user ? `${stats.user.display_name}'s Stats` : 'Stats',
      }}
    >
      <StatsProfileContent />
      <StatsDebug />
    </Page>
  )
}

interface Props extends StatsInitialState {
  forceCustomGoals?: boolean
}

const StatsProfilePage = ({ forceCustomGoals = false, ...props }: Props) => {
  if (!forceCustomGoals && !hasCustomGoals) return <StatsLegacyPage />

  return (
    <WebView
      id="stats"
      styles={{
        outer: css`
          padding-top: 1px;
        `,
        inner: isAndroidParam
          ? css`
              overflow: visible;
            `
          : '',
      }}
    >
      <StatsProfileHandler {...props}>
        <StatsProfileProviders>
          <StatsScroll>
            <StatsProfilePageContent />
          </StatsScroll>
          <StatsModal />
        </StatsProfileProviders>
      </StatsProfileHandler>
    </WebView>
  )
}

export default StatsProfilePage
